import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, IconButton, InputLabel, OutlinedInput } from '@mui/material'
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid'
import axios from 'axios';
import { useContext, useEffect, useState } from 'react'
import PersonIcon from '@mui/icons-material/Person';
import SearchIcon from '@mui/icons-material/Search';
import { tokens } from '../../theme';
import Header from '../../global/Header';
import BotDialog from './BotDialog';
import { AdminContext } from '../../context/AdminContext';
import { Remove } from '@mui/icons-material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

function BotsPage() {
    const { token } = useContext(AdminContext);
    const colors = tokens();
    const [isLoading, setLoading] = useState(true);
    const [searchKey, setSearchKey] = useState("");
    const [searchId, setSearchId] = useState(null);
    const [orderModel, setOrderModel] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [users, setUsers] = useState([]);
    const [targetUser, setTargetUser] = useState(null);
    const [userToRemove, setUserToRemove] = useState(null);
    const [editUserDialogOpen, setEditUserDialogOpen] = useState(false);
    const [removeUserDialogOpen, setRemoveUserDialogOpen] = useState(false);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10
    });

    const updateUser = async (userId, user) => {
        let contentLink = user.profile_photo_link;
        if (user.photo) {
            await axios.post(`${process.env.REACT_APP_API_URL}webAdmin/uploadUserProfilePhoto?token=${token}`, {
                profilePhoto: user.photo
            }, {
                headers: {
                    "content-type": "multipart/form-data"
                }
            })
                .catch((err) => {
                    console.log("err: " + err);
                })
                .then((response) => {
                    if (response && response.data.success === true && response.data.status === 201) {
                        delete user.photo;
                        delete user.profile_photo_link;
                        user.profile_photo_path = response.data.contentPath;
                        contentLink = response.data.contentLink;
                    }
                });
        }
        var userToUpdateOrAdd = { ...user };
        delete userToUpdateOrAdd.photo;
        delete userToUpdateOrAdd.profile_photo_link;

        if (!userId) {
            //add bot
            let randomGeneratedEmailWithTimestamp = `${user.name.toLowerCase()}.${user.surname.toLowerCase()}_${Date.now()}@bot.com`;
            await axios.post(`${process.env.REACT_APP_API_URL}webAdmin/createUser?token=${token}`, {
                ...userToUpdateOrAdd,
                firebase_id: randomGeneratedEmailWithTimestamp,
                firebase_token: randomGeneratedEmailWithTimestamp,
                email: randomGeneratedEmailWithTimestamp,
                is_bot: 1,
                is_notifiable: 0,
                is_notifiable_for_follows: 0,
                is_notifiable_for_new_words: 0,
                is_notifiable_for_new_battle: 0,
                is_notifiable_for_battle_requests: 0,
                country: "Türkiye",
                language: "en"
            })
                .catch((err) => {
                    console.log("err: " + err);
                })
                .then((response) => {
                    if (response && response.data.success === true && response.data.status === 201) {
                        setPaginationModel(prev => { return { ...prev, page: 0 } });
                        if (editUserDialogOpen) {
                            handleEditUserDialogClose();
                        }
                    }
                });
        } else {
            //update bot
            var userIx = users.findIndex(u => u.id === userId);
            console.log(userToUpdateOrAdd);
            await axios.patch(`${process.env.REACT_APP_API_URL}webAdmin/updateUser?userId=${userId}&token=${token}`, {
                user: userToUpdateOrAdd
            })
                .catch((err) => {
                    console.log("err: " + err);
                })
                .then((response) => {
                    if (response && response.data.success === true && response.data.status === 201) {
                        if (userIx !== null && userIx !== undefined && userIx !== -1) {
                            setUsers(prev => {
                                var newUsers = [...prev];
                                newUsers[userIx] = { ...newUsers[userIx], ...userToUpdateOrAdd, profile_photo_link: contentLink };
                                return newUsers;
                            })
                        }
                        if (editUserDialogOpen) {
                            setEditUserDialogOpen(false);
                        }
                    }
                });
        }

    }

    const columns = [
        {
            field: 'id', headerName: 'ID', flex: 0.2
        },
        {
            field: 'profile_photo_link', headerName: "Profil Fotoğrafı", sortable: false,
            flex: 0.1, renderCell: (params) => <img src={params.value} alt='profile-pic' style={{ height: "30px", width: "30px", margin: "auto" }} />
        },
        {
            field: 'name',
            headerName: 'AD'
        }, {
            field: 'surname',
            headerName: 'SOYAD'
        }, {
            field: 'email',
            headerName: 'E-POSTA',
            flex: 1
        }, {
            field: 'level',
            headerName: 'N SEVİYESİ'
        },
        {
            field: 'correct_answer_percentage',
            headerName: 'DOĞRU CEVAP YÜZDESİ',
        },
        {
            field: 'time_per_question_in_seconds',
            headerName: 'SÜRE (SANIYE)',
        },
        {
            field: "quiz_count",
            headerName: "KATILINAN MÜSABAKA SAYISI",
        },
        {
            field: 'actions',
            type: 'actions',
            sortable: false,
            width: 80,
            getActions: (params) => [
                <GridActionsCellItem
                    icon={<PersonIcon />}
                    label="Botu Düzenle"
                    onClick={() => setTargetUser(params.row)}
                    showInMenu
                />,
                <GridActionsCellItem
                    icon={<Remove />}
                    label="Botu Sil"
                    onClick={() => setUserToRemove(params.row)}
                    showInMenu
                />
            ],
        }
    ];

    useEffect(() => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL}webAdmin/getBots?token=${token}&startIndex=${paginationModel.pageSize * paginationModel.page}&limit=${paginationModel.pageSize}${searchKey ? `&searchKey=${searchKey}` : ""}${searchId ? `&searchId=${searchId}` : ""}${orderModel ? `&orderField=${orderModel.field}&orderType=${orderModel.sort}` : ""}`)
            .catch((err) => {
                setUsers([]);
                setRowCount(0);
                console.log("err: " + err);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 200) {
                    setUsers(response.data.users);
                    setRowCount((prevRowCount) => response.data.rowCount !== undefined ? response.data.rowCount : prevRowCount);
                }
                setLoading(false);
            });
    }, [paginationModel]);

    useEffect(() => {
        if (targetUser) {
            setEditUserDialogOpen(true);
        }
    }, [targetUser]);

    const handleEditUserDialogClose = () => {
        setTargetUser(null);
        setEditUserDialogOpen(false);
    }

    useEffect(() => {
        if (userToRemove) {
            setRemoveUserDialogOpen(true);
        }
    }, [userToRemove]);

    const handleRemoveUserDialogClose = () => {
        setUserToRemove(null);
        setRemoveUserDialogOpen(false);
    }

    const removeUser = async () => {
        await axios.delete(`${process.env.REACT_APP_API_URL}webAdmin/deleteUserWithoutApple?id=${userToRemove.id}&token=${token}`).catch((err) => {
            console.log("err: " + err);
        }).then((response) => {
            if (response && response.data.success === true && response.data.status === 201) {
                users.splice(users.findIndex(u => u.id === userToRemove.id), 1);
                handleRemoveUserDialogClose();
            }
        });
    }

    return (
        <Box sx={{ p: "75px" }}>
            <BotDialog dialogOpen={editUserDialogOpen} handleClose={handleEditUserDialogClose} targetUser={targetUser} handleFormSubmit={(values) => updateUser(targetUser ? targetUser.id : null, values)} />

            <Dialog
                open={removeUserDialogOpen}
                keepMounted
                onClose={handleRemoveUserDialogClose}
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle>Botu silmek istediğinize emin misiniz?</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Bot ve ilgili tüm veriler silinecektir. Bu işlemi geri alamazsınız.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleRemoveUserDialogClose}>Vazgeç</Button>
                    <Button onClick={() => removeUser()}>Sil</Button>
                </DialogActions>
            </Dialog>

            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box display="flex" alignItems="center" gap="20px">
                    <Header title="Botlar" subtitle="Bu sayfadan botları görüntüleyebilir ve düzenleyebilirsiniz." />
                    <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
                        <InputLabel htmlFor="search-box">Ara</InputLabel>
                        <OutlinedInput
                            id="search-box"
                            type='text'
                            onChange={(e) => {
                                setSearchKey(e.target.value ? e.target.value : "");
                            }}
                            label="Ara"
                        />
                    </FormControl>
                    <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
                        <InputLabel htmlFor="search-box">Ara(Id)</InputLabel>
                        <OutlinedInput
                            id="search-box"
                            type='number'
                            onChange={(e) => {
                                setSearchId(e.target.value ? e.target.value : "");
                            }}
                            label="Ara(Id)"
                        />
                    </FormControl>

                    <IconButton
                        aria-label="search button"
                        sx={{ background: colors.grey[900], borderRadius: "10px", padding: "12px" }}
                        onClick={() => { setPaginationModel(prev => { return { ...prev, page: 0 } }) }}
                        edge="end"
                    >
                        <SearchIcon />
                    </IconButton>

                    <IconButton
                        aria-label="add user button"
                        sx={{ background: colors.blueAccent[400], borderRadius: "10px", padding: "12px", ml: "20px", ":hover": { background: colors.blueAccent[500] } }}
                        onClick={() => setTargetUser({})}
                        edge="end"
                    >
                        <PersonAddIcon sx={{ color: 'white' }} />
                    </IconButton>

                </Box>
            </Box>
            <DataGrid
                rows={users}
                columns={columns}
                rowCount={rowCount}
                loading={isLoading}
                pageSizeOptions={[10, 25, 50, 75, 100]}
                paginationModel={paginationModel}
                paginationMode="server"
                onPaginationModelChange={setPaginationModel}
                sortingMode='server'
                onSortModelChange={(model) => {
                    setOrderModel((prev) => model && model.length > 0 ? model[0] : null);
                    setPaginationModel(prev => { return { ...prev, page: 0 } });
                }}
                disableColumnFilter
                sx={{
                    ".MuiDataGrid-columnHeaders": {
                        background: colors.grey[900]
                    },
                    marginTop: "20px"
                }}
            />
        </Box>
    )
}

export default BotsPage